var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bancos-screen"},[_c('perseo-menu-mantenimiento',{attrs:{"config":_vm.menuConfig},on:{"actualizar":_vm.handleActualizar}}),_c('bancos-listado',{ref:"listadoBancos"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }